import { ScrAuthenticationService, SignInStateEvent } from 'src/app/services/authentication.service';
import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { PendingOrderService } from 'src/app/services/pendingorder.service';
import { ScrEnvironment } from 'src/environments/environment';
import { ScrAuthorizationService } from 'src/app/services/authorization.service';
import { LinkedAccountsHeaderComponent } from '../navigation-sidebar/linked-accounts/linked-accounts-header/linked-accounts-header.component';
import { first } from 'rxjs';
import { ShortCodesRole } from '../../models/constants';
import { Router } from '@angular/router';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public signedIn?: boolean = false;
  public showSearch = false;
  public searchText = '';
  public baseDropDownUrl?: string;
  public baseUrl?: string;
  public baseHelpUrl = '';
  public servicedesk = false;
  private headerSearchElRef?: ElementRef;

  @ViewChild('headerSearch') set headerSearch(elRef: ElementRef) {
    this.headerSearchElRef = elRef;
  }
  @ViewChild(LinkedAccountsHeaderComponent) linkedAccountHeader?: LinkedAccountsHeaderComponent;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public dropDownItems: any;

  constructor(
    private authenticationService: ScrAuthenticationService,
    private authorizationService: ScrAuthorizationService,
    private pendingOrderService: PendingOrderService,
    private router: Router,
    private environment: ScrEnvironment) {

    this.baseHelpUrl = environment.helpbase;
    this.servicedesk = environment.servicedesk;
    this.baseDropDownUrl = this.environment.helpbase;
    this.baseUrl = this.environment.mbbase;

    this.dropDownItems = {
      ShortCodes101: `${this.baseUrl}/about-short-codes/short-codes-101`,
      HowShortCodesWork: `${this.baseUrl}/about-short-codes/how-short-codes-work`,
      UseCases: `${this.baseUrl}/about-short-codes/short-code-use-cases`,
      CaseStudies: `${this.baseUrl}/about-short-codes/case-studies`,
      FindAPartner: `${this.baseUrl}/partners/find-partner`,
      AboutShortCodePartners: `${this.baseUrl}/partners/about-short-code-partners`,
      BecomeAPartner: `${this.baseUrl}/partners/become-partner`,
      PartnerDirectory: `${this.baseUrl}/partners/partner-directory`,
      LearnMore: `${this.baseUrl}/learn-more/faq`,
      NewsAndInformation: `${this.baseUrl}/learn-more/news-information`,
      Resources: `${this.baseUrl}/learn-more/resources`,
      FAQs: `${this.baseUrl}/learn-more/faq`,
      FindAShortCodeButton: `${this.baseUrl}/find-short-code`,
      BookMarkIcon: `${this.baseUrl}/saved-partners`,
      Help: `${this.environment.helpbase}/help/registrant`,
      Dashboard: ``
    };

  }

  ngOnInit(): void {

    this.signedIn = this.authenticationService.isUserSignedIn();
    // this.log.debug('header: initial value user signed in ' + this.signedIn);
    this.signinStateChange();

    this.authenticationService.signInState.subscribe((sis: SignInStateEvent) => {
      // this.log.debug('header: user signed in ' + sis.signedIn);
      this.signedIn = sis.signedIn;
      this.signinStateChange();
    });
  }

  logout() {
    this.router.navigate(['/sec/logout']);
  }

  private signinStateChange(): void {
    // help is based on user type.  Help directory values are: carrier, carrierregistrant, registrant, servicedesk and prelogin.

    this.authorizationService.getAuthorizedGroups().pipe(first()).subscribe({
      next: groups => {
        // this.log.debug('user has groups ' + groups);
        (groups || []).forEach(grp => {
          switch (grp) {
            case ShortCodesRole.Carrier:
              this.dropDownItems.Help = `${this.environment.helpbase}/help/carrier/index.htm`;
              this.dropDownItems.Dashboard = `${this.environment.helpbase}/dashboard/(navbar-tab:code-management/(code-management-tab:code-lookup))`;
              break;
            case ShortCodesRole.CarrierRegistrant:
              this.dropDownItems.Help = `${this.environment.helpbase}/help/carrierregistrant/index.htm`;
              this.dropDownItems.Dashboard = `${this.environment.helpbase}/dashboard/(navbar-tab:my-shortcodes/(my-shortcode-tab:shortcode-list))`;
              break;
            case ShortCodesRole.Registrant:
              this.dropDownItems.Help = `${this.environment.helpbase}/help/registrant/index.htm`;
              this.dropDownItems.Dashboard = `${this.environment.helpbase}/dashboard/(navbar-tab:my-shortcodes/(my-shortcode-tab:shortcode-list))`;
              break;
            case ShortCodesRole.ServiceDesk:
              this.dropDownItems.Help = `${this.environment.helpbase}/help/servicedesk/index.htm`;
              this.dropDownItems.Dashboard = `${this.environment.sdbase}/dashboard/(navbar-tab:account-search)`;
              break;
            default:
            // don't do anything for other groups.
          }
        });
      },
      error: err => {
        console.error(err);
      }
    });
  }

  public get cartCount() {
    const mbObj = this.pendingOrderService.getMarketingBrochureStorage();
    if (Array.isArray(mbObj?.randomcodes)) {
      return String((mbObj?.randomcodes?.length || 0) + (mbObj?.selectcodes?.length || 0));
    }
    return String((mbObj?.randomcodes || 0) + (mbObj?.selectcodes?.length || 0));
  }

  navigateTo(path: string) {
    location.href = path;
  }

  toggleSearch() {
    this.showSearch = !this.showSearch;
    if (this.showSearch) {
      // move the focus into the serach field after the element is added to DOM.
      setTimeout(() => {
        if (this.headerSearchElRef) {
          this.headerSearchElRef.nativeElement.focus();
        }
      }, 200);
    }
  }

  clearSearch() {
    this.searchText = '';
  }
  search() {
    location.href = `${this.environment.mbbase}/search-shortcodes?search_input=${this.searchText}`;
  }

  /**
   * If user clicks outside of any area that starts with 'headerSearch', we want to hide and clear the search.
   * @param event - click event
   */
  @HostListener('document:click', ['$event'])
  click(event: Event) {
    if (event.target instanceof Element) {
      const et = event.target as Element;
      if (!et.id || !et.id.startsWith('headerSearch')) {
        this.showSearch = false;
      }
    }
  }

}
